import React, { useEffect, useState } from 'react';
import './ComTabla.css';

function ComTabla(props) {
    var [datos, setDatos] = useState([]);
    var [htmlDatos, setHtmlDatos] = useState(<></>);
    var idParque = (JSON.parse(sessionStorage.getItem("configuration"))[0].idSolarFarm);
    const { code } = props;
    const variablesAPedir = "idCT,idInverter,activePower";
    let number = 0;
    useEffect(() => {
        fetch(window.location.protocol + "//" + window.location.hostname + "/api" + "/lastData/inverters?idSolarFarm=" + idParque + "&variables=" + variablesAPedir, { method: 'GET', credentials: 'include' })
            .then(async (dataMS) => { setDatos(await dataMS.json()); })
            .catch(e => { console.log(e); })
        var interval1 = setInterval(function () {
            number++;
            if (code == sessionStorage.getItem("key")) { // No ha cambiado de página
                fetch(window.location.protocol + "//" + window.location.hostname + "/api" + "/lastData/inverters?idSolarFarm=" + idParque + "&variables=" + variablesAPedir, { method: 'GET', credentials: 'include' })
                    .then(async (dataMS) => { setDatos(await dataMS.json()); })
                    .catch(e => { console.log(e); })
            } else { // Ha cambiado de página. Cancela bucle
                clearInterval(interval1);
            }
        }, 30000)
    }, [number]);

    useEffect(() => {
        if (datos.length > 0) {
            // Agrupar
            let arrayInversores = [];
            for (let i = 11; i <= 22; i++) {
                let objetosFiltrados = datos.filter(a => a.idInverter == i);
                arrayInversores.push(objetosFiltrados);
            }

            // Pasar a número
            for (let i = 0; i < arrayInversores.length; i++) {
                for (let j = 0; j < arrayInversores[i].length; j++) {
                    arrayInversores[i][j].activePower = parseFloat(arrayInversores[i][j].activePower.substring(0, arrayInversores[i][j].activePower.length - 3)).toFixed(1);
                }
            }

            // Generar row
            let tableRows = <></>;
            //console.log(arrayInversores);
            for (let i = 0; i < arrayInversores.length; i++) {
                let currentInverter = <td className='comparativa-col-inversor'>INV&nbsp;{arrayInversores[i][0].idInverter - 10}</td>;

                let posActual = 0
                for (let j = 0; j < arrayInversores[i].length; j++) {
                    posActual++;

                    if (j > arrayInversores[i].length) { // El error está aquí
                        currentInverter = <>
                            {currentInverter}
                            <td className='comparativa-col-vacia'>---</td>
                        </>
                    } else if (posActual < arrayInversores[i][j].idCT) {
                        while (posActual < arrayInversores[i][j].idCT) {
                            currentInverter = <>
                                {currentInverter}
                                <td className='comparativa-col-vacia'>---</td>
                            </>
                            posActual++;
                        }
                        if (arrayInversores[i][j].activePower < 25) {
                            currentInverter = <>
                            {currentInverter}
                            <td className='comparativa-col-dato-rojo'>{arrayInversores[i][j].activePower}</td>
                        </>
                        } else if (arrayInversores[i][j].activePower >= 25 && arrayInversores[i][j].activePower < 50) {
                            currentInverter = <>
                            {currentInverter}
                            <td className='comparativa-col-dato-naranja'>{arrayInversores[i][j].activePower}</td>
                        </>
                        } else if (arrayInversores[i][j].activePower >= 50 && arrayInversores[i][j].activePower < 75) {
                            currentInverter = <>
                            {currentInverter}
                            <td className='comparativa-col-dato-amarillo'>{arrayInversores[i][j].activePower}</td>
                        </>
                        } else if (arrayInversores[i][j].activePower >= 75) {
                            currentInverter = <>
                            {currentInverter}
                            <td className='comparativa-col-dato-verde'>{arrayInversores[i][j].activePower}</td>
                        </>
                        } else {
                        currentInverter = <>
                            {currentInverter}
                            <td className='comparativa-col-dato'>{arrayInversores[i][j].activePower}</td>
                        </>
                        }
                    } else {
                        if (arrayInversores[i][j].activePower < 25) {
                            currentInverter = <>
                            {currentInverter}
                            <td className='comparativa-col-dato-rojo'>{arrayInversores[i][j].activePower}</td>
                        </>
                        } else if (arrayInversores[i][j].activePower >= 25 && arrayInversores[i][j].activePower < 50) {
                            currentInverter = <>
                            {currentInverter}
                            <td className='comparativa-col-dato-naranja'>{arrayInversores[i][j].activePower}</td>
                        </>
                        } else if (arrayInversores[i][j].activePower >= 50 && arrayInversores[i][j].activePower < 75) {
                            currentInverter = <>
                            {currentInverter}
                            <td className='comparativa-col-dato-amarillo'>{arrayInversores[i][j].activePower}</td>
                        </>
                        } else if (arrayInversores[i][j].activePower >= 75) {
                            currentInverter = <>
                            {currentInverter}
                            <td className='comparativa-col-dato-verde'>{arrayInversores[i][j].activePower}</td>
                        </>
                        } else {
                        currentInverter = <>
                            {currentInverter}
                            <td className='comparativa-col-dato'>{arrayInversores[i][j].activePower}</td>
                        </>
                        }
                    }

                    if (arrayInversores[i].at(-1).idCT < 31 && posActual == arrayInversores[i].at(-1).idCT) {
                        while (posActual < 31) {
                            currentInverter = <>
                                {currentInverter}
                                <td className='comparativa-col-vacia'>---</td>
                            </>
                            posActual++;
                        }
                    }


                    /*if (j == arrayInversores[i].length - 1 && posActual < 31) {
                        while(posActual < 31) {
                            currentInverter = <>
                            {currentInverter}
                           <td  className='comparativa-col-inversor'>---</td>
                        </>
                        console.error('LEIDO ' + arrayInversores[i][j].idCT + ' ' + arrayInversores[i][j].idInverter);
                        posActual++;
                        }
                    }*/
                }


                tableRows = <>
                    {tableRows}
                    <tr>{currentInverter}</tr>
                </>
            }
            //console.log(arrayInversores);
            // Juntar todo
            setHtmlDatos(tableRows);
        }
    }, [datos]);

    return (
        <table>
            <thead>
                <tr className='comparativa-cabecera'>
                    <th>Device</th>
                    <th>T1</th>
                    <th>T2</th>
                    <th>T3</th>
                    <th>T4</th>
                    <th>T5</th>
                    <th>T6</th>
                    <th>T7</th>
                    <th>T8</th>
                    <th>T9</th>
                    <th>T10</th>
                    <th>T11</th>
                    <th>T12</th>
                    <th>T13</th>
                    <th>T14</th>
                    <th>T15</th>
                    <th>T16</th>
                    <th>T17</th>
                    <th>T18</th>
                    <th>T19</th>
                    <th>T20</th>
                    <th>T21</th>
                    <th>T22</th>
                    <th>T23</th>
                    <th>T24</th>
                    <th>T25</th>
                    <th>T26</th>
                    <th>T27</th>
                    <th>T28</th>
                    <th>T29</th>
                    <th>T30</th>
                    <th>T31</th>
                </tr>
            </thead>
            <tbody>
                {htmlDatos}
            </tbody>
        </table>
    )
}

export default ComTabla;